import { aspenApi as api, stakingProductsList } from "@aspen/services";
import { generateDataCacheKey } from "@aspen/libs";
import { useQuery } from "@tanstack/react-query";
import { type IReqStakingProducts } from "@aspen/model";
import { updateYieldStakingList, useAppDispatch } from "@aspen/store";

/**
 * 获取staking产品列表。
 * @param {IReqStakingProducts} params - 获取staking产品列表所需的参数。
 */
// ADGM未开放Staking功能。暂时没有测试场景
export const useFetchStakingProducts = (params: IReqStakingProducts) => {
  const apiPath = api.savings.staking.productList;
  const queryKey = generateDataCacheKey({ api: apiPath, params: JSON.stringify(params) });
  const dispatch = useAppDispatch();
  const { error, data, isLoading, refetch } = useQuery({
    queryKey: [queryKey, Object.values(params)],
    queryFn: () => {
      return stakingProductsList(params).then(res => {
        if (res?.code == "0") {
          dispatch(updateYieldStakingList(res?.data?.rows ?? []));
          return res.data;
        }
      });
    },
  });
  return { error, data, refetch, queryKey, isLoading };
};
